export type Tag = {
  tag: string;
};

export type AddedTagResponse = {
  added_tag: string;
};

export type DeletedTagResponse = {
  deleted_tag: string;
};

export type DeleteTagsRequest = {
  hash: string;
  deletedTags: Tag[];
};

export type AddTagsRequest = {
  hash: string;
  addedTags: Tag[];
};
